import React from "react";
import Navigation from "../../components/Navigation/Navigation";
import { Row, Breadcrumb, Col, Form } from "react-bootstrap";
// import Footer from "../Footer/Footer";
import ThisYearSales from "../../components/Dashboard/ThisYearSales";
import ThisMonthSales from "../../components/Dashboard/ThisMonthSales";
import TrendingProduct from "../../components/Dashboard/TrendingProduct";
import SalesByCountries from "../../components/Dashboard/SalesByCountries";
import LastWeekSales from "../../components/Dashboard/LastWeekSales";
import TopRatedProducts from "../../components/Dashboard/TopRatedProducts";
import Tickets from "../../components/Dashboard/Tickets";
import ProductCategories from "../../components/Dashboard/ProductCategories";
import UserActivities from "../../components/Dashboard/UserActivities";
import NewUsers from "../../components/Dashboard/NewUsers";
import PaymentsDone from "../../components/Dashboard/Payments/PaymentsDone";
import PaymentsDue from "../../components/Dashboard/Payments/PaymentsDue";
import PaymentsWithdraw from "../../components/Dashboard/Payments/PaymentsWithdraw";
import BestSellers from "../../components/Dashboard/BestSellers";
import MapContainer from "../../components/GMapContainer";
import MonthlySales from "../../components/Dashboard/Sales/MonthlySales";
import TotalOrders from "../../components/Dashboard/Sales/TotalOrders";
import PendingOrders from "../../components/Dashboard/Sales/PendingOrders";
import CompletedOrders from "../../components/Dashboard/Sales/CompletedOrders";
import Loader from "../../components/Common/Loader";
import VisitorStats from "../../components/Dashboard/VisitorStats";

class Dashboard extends React.Component {
  state = {
    sideMenu: true,
    loading: true,
  };

  // Loading icon false after DOM loaded
  componentDidMount() {
    this.myInterval = setInterval(() => {
      this.setState({ loading: false });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  // Toggle side bar menu
  _onSideMenu = (active) => {
    this.setState({ sideMenu: active });
  };

  render() {
    let loader = null;
    if (this.state.loading) {
      loader = <Loader message="Loading..." />;
    }

    return (
      <div className="page-wrapper">
        {/* Navigation */}
        <Navigation onClick={this._onSideMenu} />
        {/* End Navigation */}

        <div
          className={`main-content d-flex flex-column ${
            this.state.sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          {/* Loader */}
          {loader}
          {/* End Loader */}

          {/* Breadcrumb */}
          <div className="main-content-header">
            <Breadcrumb>
              <h1>Tráfico</h1>
            </Breadcrumb>
          </div>
          {/* End Breadcrumb */}

          <Row className="mb-3">
            <Col lg={3}>
            <Form.Group as={Col} controlId="unit">
                <Form.Label>Unidad</Form.Label>
                <Form.Select defaultValue="Choose...">
                    <option>99</option>
                </Form.Select>
            </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              {/* File path: src/components/MapContainer.js */}
              <MapContainer />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Dashboard;
